module.exports = __webpack_public_path__ + "static/how-technology-can-increase-the-value-of-cre-5467fd8f51ea7e4da694ea964187ceeb.png";